export const scoringTargets = {
  'nclex': {
    "Adult Health": {
      "Cardiovascular": 64,
      "Endocrine": 57,
      "Gastrointestinal": 54,
      "Hematologic": 56,
      "Immune/Infectious Disease": 63,
      "Integumentary": 65,
      "Multisystem": 58,
      "Musculoskeletal": 61,
      "Neurologic": 55,
      "Reproductive": 46,
      "Respiratory": 58,
      "Urinary and Renal": 50,
      "Visual and Auditory": 60
    },
    "Child Health": {
      "Cardiovascular": 43,
      "Endocrine": 41,
      "Gastrointestinal": 47,
      "Growth and Development": 56,
      "Hematologic": 46,
      "Immune/Infectious Disease": 48,
      "Integumentary": 53,
      "Multisystem": 62,
      "Musculoskeletal": 47,
      "Neurologic": 57,
      "Reproductive": 35,
      "Respiratory": 55,
      "Urinary and Renal": 58,
      "Visual and Auditory": 58
    },
    "Critical Care": {
      "Critical Care": 49
    },
    "Fundamentals": {
      "Fluid, electrolytes, and acid-base balance": 57,
      "Safety and Infection Control": 53,
      "Basic Care and Comfort": 57,
      "Nutrition and Elimination": 55
    },
    "Maternal & Newborn Health": {
      "Antepartum": 38,
      "Labor & Delivery": 45,
      "Newborn": 46,
      "Postpartum": 41
    },
    "Mental Health": {
      "Anxiety Disorders, Trauma, and Addiction": 54,
      "Cognitive and Developmental Disorders": 50,
      "Foundations and Therapeutic Communication": 69,
      "Mood and Personality Disorders": 46
    },
    "Pharmacology": {
      "Cardiovascular": 58,
      "Endocrine": 58,
      "Gastrointestinal": 56,
      "Hematologic/Oncologic": 50,
      "Immune": 48,
      "Integumentary": 58,
      "Musculoskeletal": 55,
      "Neurologic": 57,
      "Psychiatric": 46,
      "Reproductive": 41,
      "Respiratory": 45,
      "Urinary and Renal": 42,
      "Medication administration": 61,
      "Visual and Auditory": 53
    },
    "Management of Care": {
      "Assignment and Delegation": 68,
      "Management Concepts": 61,
      "Prioritization": 55
    }
  },
  'inbde': {
    "Fields of Dentistry": {
      "Operative Dentistry": 63,
      "Pediatric Dentistry": 62,
      "Periodontics": 63,
      "Oral Surgery": 65,
      "Endodontics": 65,
      "Orthodontics": 61,
      "Prosthodontics": 62,
      "Preventive Dentistry": 64
    },
    "Oral Pathology and Oral Radiology": {
      "Oral Pathology": 63,
      "Oral Radiology": 68
    },
    "Medicine": {
      "Pathology": 61,
      "Microbiology": 57,
      "Developmental Disorders": 61
    },
    "Pharmacology": {
      "Anesthesia and Pain Management": 60,
      "Antibiotics, Antifungals, and Antivirals": 61,
      "Systems Pharmacology": 56
    },
    "Clinical Management": {
      "Patient Management": 65,
      "Practice Management": 56,
      "Ethics, Law, and Behavioral Science": 71,
      "Medical Complications": 63
    },
    "Anatomy and Physiology": {
      "Head and Neck Anatomy": 63,
      "Dental Anatomy and Occlusion": 65,
      "Temporomandibular Joint": 58,
      "Physiology": 62
    },
    "Research": {
      "Evidence Based Dentistry": 62,
      "Interpreting Graphical Data": 61,
      "Biostatistics": 55,
      "Applied Research": 61
    },
    "Case Sets": {
      "Anesthesia and Pain Management": 78,
      "Antibiotics, Antifungals, and Antivirals": 87,
      "Applied Research": 67,
      "Biostatistics": 63,
      "Clinical Management": 68,
      "Dental Anatomy and Occlusion": 76,
      "Developmental Disorders": 66,
      "Endodontics": 65,
      "Ethics, Law, and Behavioral Science": 89,
      "Genetics": 78,
      "Head and Neck Anatomy": 67,
      "Medical Complications": 82,
      "Microbiology": 39,
      "Operative Dentistry": 76,
      "Oral Pathology": 70,
      "Oral Radiology": 78,
      "Oral Surgery": 68,
      "Orthodontics": 68,
      "Pathology": 64,
      "Pediatric Dentistry": 68,
      "Periodontics": 61,
      "Physiology": 76,
      "Practice Management": 78,
      "Preventive Dentistry": 72,
      "Prosthodontics": 72,
      "Systems Pharmacology": 63,
      "Temporomandibular Joint": 57,
    },
    "Simulation Exam": {
      "Anesthesia and Pain Management": 62,
      "Antibiotics, Antifungals, and Antivirals": 68,
      "Applied Research": 67,
      "Biostatistics": 63,
      "Clinical Management": 69,
      "Dental Anatomy and Occlusion": 63,
      "Developmental Disorders": 71,
      "Endodontics": 72,
      "Ethics, Law, and Behavioral Science": 69,
      "Evidence Based Dentistry": 60,
      "Genetics": 46,
      "Head & Neck Anatomy": 82,
      "Medical Complications": 74,
      "Microbiology": 76,
      "Operative Dentistry": 62,
      "Oral Pathology": 74,
      "Oral Radiology": 76,
      "Oral Surgery": 65,
      "Orthodontics": 65,
      "Pathology": 74,
      "Pediatric Dentistry": 60,
      "Periodontics": 69,
      "Physiology": 79,
      "Practice Management": 63,
      "Preventive Dentistry": 57,
      "Prosthodontics": 66,
      "Systems Pharmacology": 66,
      "Temporomandibular Joint": 57,
    }
  },
  'med-school': {
    "Biochemistry": {
      "Cellular": 49,
      "Laboratory Techniques": 52,
      "Metabolism": 51,
      "Molecular": 47,
      "Nutrition": 57
    },
    "Biostatistics": {
      "Biostatistics and Epidemiology": 50
    },
    "Cardiology": {
      "Anatomy": 53,
      "Pathology": 56,
      "Pathophysiology": 52,
      "Pharmacology": 57,
      "Physiology": 52
    },
    "Dermatology": {
      "Pathology": 58,
      "Pathophysiology": 59,
      "Pharmacology": 41
    },
    "Endocrinology": {
      "Pathology": 61,
      "Pathophysiology": 53,
      "Pharmacology": 58,
      "Physiology": 60
    },
    "Gastroenterology": {
      "Anatomy": 42,
      "Pathology": 53,
      "Pathophysiology": 53,
      "Pharmacology": 57
    },
    "Genetics": {
      "Clinical Genetics": 56,
      "DNA Structure, Replication, and Repair": 46,
      "Gene Expression and Regulation": 50
    },
    "Hematology & Oncology": {
      "Histology": 35,
      "Pathology": 58,
      "Pathophysiology": 60,
      "Pharmacology": 59,
      "Physiology": 67
    },
    "Immunology": {
      "Immunology": 68,
      "Pathology": 65,
      "Pharmacology": 60,
      "Pathophysiology": 65
    },
    "Microbiology": {
      "Antimicrobials": 46,
      "Basic Bacteriology": 47,
      "Clinical Bacteriology": 53,
      "Mycology": 62,
      "Parasitology": 54,
      "Systems": 57,
      "Virology": 54
    },
    "Musculoskeletal": {
      "Anatomy": 49,
      "Pathology": 57,
      "Pathophysiology": 53,
      "Pharmacology": 62,
      "Physiology": 62
    },
    "Nephrology": {
      "Histology": 52,
      "Pathology": 59,
      "Pathophysiology": 53,
      "Pharmacology": 43,
      "Physiology": 56
    },
    "Neurology": {
      "Anatomy": 54,
      "Pathology": 53,
      "Pathophysiology": 58,
      "Pharmacology": 49
    },
    "Pharmacology (Principles)": {
      "Pharmacokinetics and Pharmacodynamics": 40,
      "Toxicities and Adverse Effects": 46
    },
    "Psychiatry": {
      "Behavioral Science": 65,
      "Pathology": 62,
      "Pathophysiology": 74,
      "Pharmacology": 57
    },
    "Public Health Sciences": {
      "Ethics and Communications": 60,
      "Social Sciences": 54
    },
    "Pulmonology": {
      "Anatomy": 64,
      "Pathology": 57,
      "Pathophysiology": 57,
      "Pharmacology": 64,
      "Physiology": 54
    },
    "Reproduction": {
      "Anatomy": 56,
      "Pathology": 56,
      "Pathophysiology": 56,
      "Pharmacology": 59
    }
  }
};

